import React from 'react';
import { List } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { hasMinimumLength } from '@/utils/resultsHelper';

const RequestWorkspaceListItem = ({
  header = 'name.simple',
  url,
  value,
}) => (
  <List.Item className="aridhia-request-workspace-list-item">
    <List.Header>
      <FormattedMessage id={`request.list.workspace.${header}.title`} />
    </List.Header>
    {hasMinimumLength(url) && (
    <List.Description className="aridhia-form-item-description">
      <a href={url} target="_blank" rel="noopener noreferrer">
        {value}
      </a>
    </List.Description>
    )}
    {!hasMinimumLength(url) && (<List.Description className="aridhia-form-item-description" content={value} />)}
  </List.Item>
);

export default RequestWorkspaceListItem;
